<section class="key-platform-features" aria-labelledby="key-platform-features-title">
  <div class="key-platform-features--container">
    <div class="key-platform-features--header">
      <span class="key-platform-features--accent" aria-hidden="true"></span>
      <h2 id="key-platform-features-title" class="key-platform-features--title">
        {{ sectionTitle }}
      </h2>
      <span class="key-platform-features--line" aria-hidden="true"></span>
    </div>

    <p class="key-platform-features--intro">
      Core responsibilities in steering and operating the digital health ecosystem under the approved governance framework.
    </p>

    <ul class="key-platform-features--list">
      @for (feature of features; track feature.id) {
        <li class="mandate-item">
          <p class="mandate-item--text">{{ feature.statement }}</p>
        </li>
      }
    </ul>
  </div>
</section>
